/**
 * MapControls.jsx - Zoom and navigation controls for the world map
 */

import React from 'react';

const MIN_ZOOM = 0.5;
const MAX_ZOOM = 2.0;

export function MapControls({
  zoom,
  setZoom,
  onCenterPlayer,
}) {
  return (
    <div className="wm-map-controls">
      <button onClick={() => setZoom(z => Math.min(MAX_ZOOM, z + 0.2))}>+</button>
      <span>{Math.round(zoom * 100)}%</span>
      <button onClick={() => setZoom(z => Math.max(MIN_ZOOM, z - 0.2))}>-</button>
      <button onClick={onCenterPlayer}>🎯</button>
    </div>
  );
}

export default MapControls;
